import script from "./CreateTelegramTopicDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateTelegramTopicDrawer.vue?vue&type=script&setup=true&lang=js"

import "./CreateTelegramTopicDrawer.vue?vue&type=style&index=0&id=d8b772bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8b772bc"]])

export default __exports__